module.exports = __webpack_public_path__ + "static/media/header_logo.005045b7.png";